<ziro-loading-block [hidden]="!isLoading" class="m-auto"></ziro-loading-block>
@if (!isLoading) {
  <div>
    <ziro-shared-voicemail-groups-memberships-form
      [inventory]="inventory"
      [initialEntity]="originalEntity"
      [fieldConfig]="fieldConfig"
      [microsoft360View]="microsoft360View"
    ></ziro-shared-voicemail-groups-memberships-form>
  </div>
}
